// dashboard strings (fr).
// Machine-drafted — review with a native speaker before launch.
const dashboard = {
	dashboard: {
		title: 'Tableau de bord',
		cards: 'Cartes',
		searchCardPlaceholder: 'Saisissez le titre de la carte',
		viewMore: 'Voir plus',
		createNewCard: 'Créer une nouvelle carte',
		createNewCardDesc: 'CardClan vous encourage à vous connecter avec vos proches et à partager de l’amour avec eux.',
		letsCreate: 'Créons',
		selectTemplate: 'Sélectionner un modèle',
		searchCategoryPlaceholder: 'Saisissez le nom de la catégorie',
		seeLess: 'Voir moins',
		moreCount: '+%{count} de plus',
		notEnoughData: 'Pas assez de données à afficher.',
		emailsOpenRate: 'Taux d’ouverture des e-mails',
		cardsOpenRate: 'Taux d’ouverture des cartes',
		tour: {
			dashboardTitle: 'Tableau de bord',
			dashboardDesc: 'Bienvenue sur votre tableau de bord ! Vous pouvez y voir un aperçu de vos activités.',
			createCardTitle: 'Créer une carte',
			createCardDesc: 'Cliquez ici pour créer une nouvelle carte à partir d’un modèle.',
			searchCardsTitle: 'Rechercher des cartes',
			searchCardsDesc: 'Vous pouvez rechercher vos cartes existantes ici.',
		},
		stats: {
			cardsStatistics: 'Statistiques des cartes',
			graph: 'Graphique',
			contactsEngagement: 'Engagement des contacts',
			contactEngagement: 'Engagement du contact',
			emailsOpened: 'E-mails ouverts',
			cardsOpened: 'Cartes ouvertes',
			conversionRate: 'Taux de conversion',
			totalReactions: 'Réactions totales',
			totalComments: 'Commentaires totaux',
			totalDownloads: 'Téléchargements totaux',
			last7Days: '7 derniers jours',
			last15Days: '15 derniers jours',
			last30Days: '30 derniers jours',
			last2Months: '2 derniers mois',
			last6Months: '6 derniers mois',
			lastYear: 'Dernière année',
			allCards: 'Toutes les cartes',
		},
		swal: {
			cardAlreadyDeliveredTitle: 'Carte déjà livrée',
			cardAlreadyDeliveredText: 'Vous pouvez cloner cette carte pour en programmer une nouvelle',
			workflowCardTitle: 'Cette carte est utilisée dans un flux de travail',
			workflowCardText: 'Modifier les balises de fusion ou le contenu peut casser vos flux de travail existants. Voulez-vous vraiment continuer ?',
			cancel: 'Annuler',
			editAnyway: 'Modifier quand même',
			openCardError: 'Un problème est survenu lors de l’ouverture de cette carte. Veuillez contacter le support',
			cardClonedTitle: 'Carte clonée avec succès',
			cardClonedText: 'La carte a été clonée dans l’espace de travail sélectionné.',
			deleteConfirmTitle: 'Êtes-vous sûr ?',
			deleteConfirmText: 'Voulez-vous supprimer cette carte ?',
			no: 'Non',
			yes: 'Oui',
			error: 'Erreur',
			warning: 'Avertissement',
			noCategoriesFound: 'Aucune catégorie de design trouvée !',
			oopsExclaim: 'Oups !',
			oops: 'Oups',
			noWorkspaces: 'Il semble que vous n’ayez pas encore d’espace de travail.',
		},
	},
};
export default dashboard;
